import { render, staticRenderFns } from "./itemBlock.vue?vue&type=template&id=a22b1098&scoped=true&"
import script from "./itemBlock.vue?vue&type=script&lang=js&"
export * from "./itemBlock.vue?vue&type=script&lang=js&"
import style0 from "./itemBlock.vue?vue&type=style&index=0&id=a22b1098&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22b1098",
  null
  
)

export default component.exports